import React from "react";
import avatar from "../../Assets/avatar.png";
import moment from "moment";

const AuthorChat = ({ chatObj }) => {
  return (
    <div className="chat">
      <div className="chat_box_author">
        <div className="chat_person">{chatObj?.sender_name}</div>
        <div className="chat_info">
          <p>{chatObj?.reply}</p>
          <span>{moment(chatObj.updated_at).fromNow()}</span>
        </div>
      </div>
    </div>
  );
};

export default AuthorChat;
